import { useTheme } from "app/shared";
import arbitrumIcon from "assets/img/icons/arb-logo.svg";
import bnbIcon from "assets/img/icons/bsc.svg";
import ethIcon from "assets/img/icons/eth-chain.svg";
import lineaIcon from "assets/img/icons/linea-chain.svg";
import baseIcon from "assets/img/icons/token_base.svg";
import immutableIcon from "assets/img/icons/immutable-zkevm.svg";
import { FC } from "react";
import { useSwitchChain } from "wagmi";
import { NetworkOption, NetworkSelectProps } from "app/types";

import styles from "./TokenSelect.module.scss";

const NetworkSelect: FC<NetworkSelectProps> = ({
  selectedNetwork,
  onChange,
}) => {
  const { theme } = useTheme();
  const { switchChain } = useSwitchChain();

  const options = [
    { value: "Base", label: "Base", icon: baseIcon },
    { value: "Linea", label: "Linea", icon: lineaIcon },
    { value: "BNB", label: "BNB", icon: bnbIcon },
    { value: "Arbitrum", label: "Arbitrum", icon: arbitrumIcon },
    { value: "ETH", label: "ETH", icon: ethIcon },
    { value: "ImmutableZkEVM", label: "Immutable ZkEVM", icon: immutableIcon },
  ];

  const networkChainIds: Record<NetworkOption, number> = {
    Base: 8453,
    Linea: 59144,
    BNB: 56,
    Arbitrum: 42161,
    ETH: 1,
    ImmutableZkEVM: 13371,
  };

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value as NetworkOption;
    onChange(value);
    const chainId = networkChainIds[value];
    if (switchChain && chainId) {
      switchChain({ chainId });
    }
  };

  return (
    <>
      <label htmlFor="network-select" className={styles.label}>
        <span>Select Network:</span>
      </label>
      <div className={styles.customSelectWrapper}>
        <span className={styles.selectedIcon}>
          <img
            src={options.find((opt) => opt.value === selectedNetwork)?.icon}
            alt={selectedNetwork}
            className={theme === "dark" ? styles.darkIcon : styles.icon}
          />
        </span>
        <select
          id="network-select"
          className={`${styles.select} ${
            theme === "dark" ? styles.darkTheme : ""
          }`}
          value={selectedNetwork}
          onChange={handleChange}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </>
  );
};

export default NetworkSelect;
